import gql from 'graphql-tag';
import { unitFragments, unitContactFragments, unitAddressFragments } from './unitFragments';

export const UNIT_SEARCH = gql`
  query unitSearch($term: String!, $limit: Int, $offset: Int, $isCompany: Boolean, $isPensionCompany: Boolean, $date: Date!) {
    unitSearch (term: $term, limit: $limit, offset: $offset, isCompany: $isCompany, isPensionCompany: $isPensionCompany, date: $date) {
      ...unitFragments,
      ...unitContactFragments,
      ...unitAddressFragments,
      closedDate,
      openedDate
    }
  },
  ${unitFragments}
  ${unitContactFragments}
  ${unitAddressFragments}
`;
